import { Trash2 } from "lucide-react";
import { TextField, SelectField } from "./Fields";
import { LUGARES, FRECUENCIAS, MOTIVOS } from "./constants";
import { formatPrice } from "@/lib/api";

export const FoodFields = ({ food, idx, pi, errors, onChange, onRemove, canRemove }) => {
  const p = `m${pi}.a${idx}`;
  const set = (k) => (e) => onChange({ ...food, [k]: e.target.value });
  const tid = (k) => `cf-pet-${pi}-food-${idx}-${k}`;
  const ppk = Number(food.kg) > 0 && Number(food.precio) > 0 ? Number(food.precio) / Number(food.kg) : null;

  return (
    <div data-testid={`cf-pet-${pi}-food-${idx}`} className="rounded-2xl bg-cream-2/70 border border-[#E3E7E2] p-4 space-y-3">
      <div className="flex items-center justify-between">
        <p className="text-xs font-bold uppercase tracking-wider text-muted-moss">Alimento {idx + 1}</p>
        {canRemove && (
          <button type="button" data-testid={tid("remove")} onClick={onRemove} className="inline-flex items-center gap-1 text-xs font-semibold text-muted-moss hover:text-red-500">
            <Trash2 className="w-3.5 h-3.5" /> Quitar
          </button>
        )}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <TextField label="Marca" testId={tid("marca")} value={food.marca} onChange={set("marca")} error={errors[`${p}.marca`]} placeholder="Ej: Pro Plan" />
        <TextField label="Línea / variedad" optional testId={tid("linea")} value={food.linea} onChange={set("linea")} placeholder="Ej: Adulto raza pequeña" />
        <TextField label="Tamaño de la bolsa (kg)" testId={tid("kg")} type="number" inputMode="decimal" min="0" step="0.1" value={food.kg} onChange={set("kg")} error={errors[`${p}.kg`]} placeholder="Ej: 3" />
        <TextField label="Precio que pagas (₡)" testId={tid("precio")} type="number" inputMode="numeric" min="0" value={food.precio} onChange={set("precio")} error={errors[`${p}.precio`]} placeholder="Ej: 15000" />
        <SelectField label="¿Dónde lo compras?" testId={tid("lugar")} options={LUGARES} value={food.lugar_compra} onChange={set("lugar_compra")} error={errors[`${p}.lugar_compra`]} />
        <TextField label="Nombre del lugar" testId={tid("lugar-nombre")} value={food.lugar_nombre} onChange={set("lugar_nombre")} error={errors[`${p}.lugar_nombre`]} placeholder="Ej: Veterinaria San Rafael" />
        <SelectField label="¿Cada cuánto lo compras?" testId={tid("frecuencia")} options={FRECUENCIAS} value={food.frecuencia} onChange={set("frecuencia")} error={errors[`${p}.frecuencia`]} />
        <SelectField label="¿Por qué elegiste este alimento?" testId={tid("motivo")} options={MOTIVOS} value={food.motivo} onChange={set("motivo")} error={errors[`${p}.motivo`]} />
      </div>
      {ppk && <p data-testid={tid("ppk")} className="text-xs text-muted-moss">≈ {formatPrice(ppk)} por kg</p>}
    </div>
  );
};
